import React, { useContext, useEffect } from 'react';
import { usePlaylistStateStore, } from '@annunciate/core';
import { DisplayMode } from '@annunciate/core';
import { Series } from '@annunciate/ui/dist/components/collection/mode/Series/Series';
import { Carousel } from '@annunciate/ui/dist/components/collection/mode/Carousel';
import { Tile } from '@annunciate/ui/dist/components/collection/mode/Tile';
import { NavigationContext } from '../../providers';
const { setAvailablePlaylistContext } = usePlaylistStateStore.getState();
export const Collection = ({ collection }) => {
    const { onNavigateToItem } = useContext(NavigationContext);
    useEffect(() => {
        if (collection?.displayMode === DisplayMode.REDIRECT) {
            if (collection?.redirectParentId) {
                const item = {
                    __typename: collection.__typename,
                    id: collection.redirectParentId,
                };
                if (onNavigateToItem)
                    onNavigateToItem(item);
            }
            else {
                throw new Error(`Unable to redirect to an unknown Collection for Collection '${collection?.id}'`);
            }
        }
    }, [
        collection?.id,
    ]);
    const mode = collection.displayMode;
    useEffect(() => {
        if (collection && collection.displayMode !== DisplayMode.SERIES) {
            setAvailablePlaylistContext({
                collection,
            });
        }
    }, [collection?.id]);
    switch (mode) {
        case DisplayMode.CAROUSEL:
            return React.createElement(Carousel, { collection: collection });
        case DisplayMode.SERIES:
            return React.createElement(Series, { collection: collection });
        case DisplayMode.TILED:
            return React.createElement(Tile, { collection: collection });
        case DisplayMode.REDIRECT:
            return React.createElement(React.Fragment, null);
        default:
            throw new Error(`Unknown collection display mode '${mode}' for collection '${collection.id}'`);
    }
};
export const MemoizedCollection = React.memo(Collection, ({ collection: prevCollection }, { collection: nextCollection }) => {
    const isIdIdentical = prevCollection?.id === nextCollection?.id;
    return isIdIdentical;
});
//# sourceMappingURL=Collection.js.map